import React from 'react';

import { Form } from 'react-final-form';
import { Link } from 'react-router-dom';

import PhoneVerification from '../components/Auth/PhoneVerification';
import { FormInput } from '../components/FormElements';
import TenantConfig from '../config';
import links from '../constants/links';

const getClassNameByDestination = (destination) => {
  return destination === '/admin' || destination === '/confirm' ? 'admin-form' : 'auth-form';
};

const getButtonTextByDestination = (destination) => {
  if (destination === '/admin') {
    return 'Sign Up';
  }
  if (destination === '/confirm') {
    return 'Next';
  }
  return 'Register';
};

const getTitleTextByDestination = (destination) => {
  if (destination === '/confirm') {
    return 'Welcome';
  }
  return 'Hello! You are invited to Signup.';
};

const renderIfNotRegistered = (destination) => {
  return destination !== '/confirm';
};

export default function InviteForm({
  phone,
  intentId,
  destination,
  formOptions,
  credentials,
  handleTermChecks,
  parsePhoneNumber,
  handleFormSubmit,
  onPhoneVerificationSubmit,
  onPhoneVerificationRecoverySubmit,
}) {
  const className = destination === '/admin' ? 'admin-form' : 'auth-form';

  return (
    <div className={`admin ${className === 'auth-form' ? 'invite-dynamic' : ''}`}>
      {intentId && phone ? (
        <>
          <PhoneVerification
            onSubmit={onPhoneVerificationSubmit}
            phone={phone}
            onResendCode={onPhoneVerificationRecoverySubmit}
            title="Enter confirmation code to save changes"
            className={destination === '/admin' ? 'admin' : 'auth'}
          />
        </>
      ) : (
        <>
          {className === 'admin-form' && (
            <img className="logo" src={TenantConfig.headerLogo} alt="logo" />
          )}
          <Form
            initialValues={{
              phone: (credentials.phone && parsePhoneNumber(credentials.phone)) || '+1-___-___-___',
              firstname: credentials.firstName || '',
              lastname: credentials.lastName || '',
            }}
            onSubmit={handleFormSubmit}
            validate={(values) => {
              const errors = {};
              if (values.password && values.confirmpassword !== values.password) {
                errors.confirmpassword = 'Passwords must match';
              }
              return errors;
            }}
            render={({ handleSubmit, submitting, pristine, submitError }) => {
              return (
                <form className={className} onSubmit={handleSubmit}>
                  <div className={`${className}__title`}>
                    <h1>{getTitleTextByDestination(destination)}</h1>
                  </div>
                  {className === 'admin-form' && (
                    <div className={`${className}__description`}>Please confirm your details</div>
                  )}
                  <div className={`${className}__divider`}></div>
                  {formOptions.fields.map((f) => {
                    return (
                      <div className={`${className}__${f.name}`} key={`${className}__${f.name}`}>
                        <FormInput {...f} />
                      </div>
                    );
                  })}
                  {className === 'auth-form' && (
                    <>
                      <div className="registerCustomCheckBox">
                        <label htmlFor={`terms-checks`}>
                          <input
                            type="checkbox"
                            id={`terms-checks`}
                            name="terms-checks"
                            onChange={handleTermChecks}
                          />
                          <span>
                            I agree to the{' '}
                            <a
                              href={links.globalLinks.TermsAndConditionLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {links.globalLinks.TermsAndConditionText}
                            </a>
                          </span>
                        </label>
                      </div>
                    </>
                  )}
                  <div className="auth-form__submit-error">{submitError && submitError}</div>
                  <div className={`${className}__button`}>
                    <button
                      className="btn primary-btn"
                      type="submit"
                      disabled={submitting || pristine}
                    >
                      {getButtonTextByDestination(destination)}
                    </button>
                  </div>
                  {renderIfNotRegistered(destination) && (
                    <div className={`${className}__login`}>
                      {className === 'admin-form' ? (
                        <>
                          Have an account? <Link to="/auth/sign-in">Login</Link>
                        </>
                      ) : (
                        <Link to="/auth/sign-in">Already registered? Sign in!</Link>
                      )}
                    </div>
                  )}
                </form>
              );
            }}
          />
        </>
      )}
    </div>
  );
}
